import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_COUNSELLOR_API_BASE_URL;

export const listChatAvailabilityByAppName = async (appName) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/chat-availability`,
            {
                params: {
                    app_name: appName
                }
            }
        );

        return response.data; // array of chat availability
    } catch (error) {
        console.error("Error fetching chat availability:", error);
        throw error;
    }
};